/* eslint-disable import/prefer-default-export */

export const variables = {
  //?  MEDIA QUERIES
  mobil: '425px',
  tablet: '768px',
  desktop1024: '1024px',

  //? CONTAINERS
  mobileContainerCarrousel: '280px',
  mobileContainer: '295px',
  tabletContainer: '734px',
  desktopContainerPublication: '912px',
  desktopContainer: '1195px',
  cardsContainerTablet: '648px',
  cardsContainerDesktop: '875px',
  searchHeightContainer: '142px',
  maxWidthPublicationDesktop: '1282px',
  maxWidthBorderDesktop: '912px',

  //? STANDARDS SIZE
  size0: '0',
  size4: '4px',
  size6: '6px',
  size8: '8px',
  size10: '10px',
  size12: '12px',
  size14: '14px',
  size16: '16px',
  size18: '18px',
  size20: '20px',
  size22: '22px',
  size24: '24px',
  size26: '26px',
  size28: '28px',
  size30: '30px',
  size32: '32px',
  size34: '34px',
  size36: '36px',
  size38: '38px',
  size40: '40px',
  size42: '42px',
  size44: '44px',
  size46: '44px',
  size48: '48px',
  size50: '50px',
  size60: '60px',
  size64: '64px',
  size75: '75px',
  size100: '100px',

  //? PERCENTAGES
  pct100: '100%',
  pct90: '90%',
  pct80: '80%',
  pct70: '70%',
  pct60: '60%',
  pct50: '50%',
  pct40: '40%',
  pct30: '30%',
  pct25: '25%',
  pct20: '20%',
  pct15: '15%',
  pct10: '10%',
  pct5: '5%',

  //?GRIDS
  grid305: '305px',
  grid320: '320px',
  grid414: '414px',

  //*Border
  border: '0.25px',
  borderB: '1px',

  //*Border Radius
  radiusCircle: '50%',
  borderRadius1px: '1.3',
  radiusBtn: '3px',
  borderRadius4: '4px',
  borderRadius8: '8px',
  borderRadius16: '16px',

  //*Shadows
  shadow1: '1.6875px 1.6875px 1.6875px rgba(0, 0, 0, 0.1)',
  shadow2: '2px 2px 2px rgba(0, 0, 0, 0.1)',
  shadow3: '2px 0px 4px rgba(140, 137, 121, 0.15)',
  shadow4: '0px 2px 2px rgba(64, 64, 64, 0.25)',
  shadowInset: 'inset 0px -2px 0px rgba(0, 0, 0, 0.1)',

  //*Line spacing
  lineSpacing: '1.3',

  //? COLORS
  red: '#F34A53',
  lightPink: '#fce7e4',
  darkPink: '#ffd4cd',
  black: '#262526',
  darkGray: ' #404040',
  lightGray: ' #8c8979',
  white: '#f6f6f6',
  absoluteWhite: '#ffffff',
  background: '#fbfbfb',
  blue: '#4080fe',

  //*Gradients
  photoPreview:
    'linear-gradient(180deg, rgba(38, 37, 38, 0) 35.5%, rgba(38, 37, 38, 0.66) 100%)',
  backgroundBanner:
    'linear-gradient(180deg, rgba(38, 37, 38, 0.085) 0%, rgba(38, 37, 38, 0.5) 100%)',

  //?FONTS
  font: 'Cabin',

  //* Font sizes
  fontSize8: '8px',
  fontSize9: '9px',
  fontSize10: '10px',
  fontSize12: '12px',
  fontSize14: '14px',
  fontSize16: '16px',
  fontSize18: '18px',
  fontSize24: '24px',
  fontSize26: '26px',
  fontSize36: '36px',

  //* Font weights
  regular: '400',
  medium: '500',
  bold: '700',

  //?COVERS
  //* Maximum cover size
  coverImageDesktop: '1282px',

  //*width Logo
  logoMobil: '57px',
  logoTablet: '65px',
  logoDesktop: '82px',

  //?SEARCHS
  //* Header search engines
  searchHeaderWidthTablet: '265px',

  //* Searchers
  searchDesktop: '650px',
  searchHeightDesktop: '240px',

  //? COVERS
  //* Title Covers Mobil
  titleCoverWidthMobil: '320px',
  titleCoverHeightMobil: '95px',

  //* Title Covers Tablet
  titleCoverHeightTablet: '145px',
  titleCoverWidthDesktop: '1280px',

  //* Title Covers Desktop
  titleCoverHeightDesktop: '130px',
  detailsCoverHeighMovil: '286px',

  //* Title Cover Detail Offer
  coverDetailOfferDesktop: '240px',

  //? BUTTONS
  BtnWhatsappDetailsMovil: '130px',
  BtnWhatsappDetailsTablet: '165px',
  BtnWhatsappDetailsDesktop: '175px',
  BtnM: '190px',
  BtnBg: '270px',

  //?CARD
  cardHeightDesktop: '147px',
  cardHeightTablet: '113px',

  //? TOOLTIPS
  toolTipS: '200px',
  toolTipM: '250px',

  //?ROOM DETAILS ICONS
  roomIconMobil: '55px',
  roomIconTablet: '78px',

  //? PICTURES OF DETAILS IN DESKTOP
  //* Width Size
  widthSizePictureDetail: '400px',

  //?INPUTS
  availabilityMobil: '140px',
  availabilityTablet: '140px',
  availabilityDesktop: '170px',
  inputHeightTablet: '274px',
  inputHeightDesktop: '405px',

  //UPLOAD
  uploadHeightContainerMobil: '185px',
};
